import React from 'react';
import { Header } from '../components/common/Header';
import { Footer } from '../components/common/Footer';

export function LegalInformation() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="bg-white rounded-lg shadow-sm p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-6">特定商取引法に基づく表記</h1>
          
          <div className="prose prose-blue max-w-none">
            <table className="w-full border-collapse">
              <tbody>
                <tr className="border-b border-gray-200">
                  <th className="py-4 px-6 bg-gray-50 text-left text-gray-700 font-medium w-1/3">販売業者の名称</th>
                  <td className="py-4 px-6">
                    株式会社クローバー<br />
                    代表者 木村 政治
                  </td>
                </tr>

                <tr className="border-b border-gray-200">
                  <th className="py-4 px-6 bg-gray-50 text-left text-gray-700 font-medium">運営統括責任者</th>
                  <td className="py-4 px-6">木村 政治</td>
                </tr>

                <tr className="border-b border-gray-200">
                  <th className="py-4 px-6 bg-gray-50 text-left text-gray-700 font-medium">法人番号</th>
                  <td className="py-4 px-6">7040001136782</td>
                </tr>

                <tr className="border-b border-gray-200">
                  <th className="py-4 px-6 bg-gray-50 text-left text-gray-700 font-medium">会社法人等番号</th>
                  <td className="py-4 px-6">040001136782</td>
                </tr>

                <tr className="border-b border-gray-200">
                  <th className="py-4 px-6 bg-gray-50 text-left text-gray-700 font-medium">所在地</th>
                  <td className="py-4 px-6">〒277-0863 千葉県柏市豊四季１６７−４１</td>
                </tr>

                <tr className="border-b border-gray-200">
                  <th className="py-4 px-6 bg-gray-50 text-left text-gray-700 font-medium">連絡先</th>
                  <td className="py-4 px-6">
                    電話番号: 080-5403-1349<br />
                    メールアドレス: hal.masaharu@gmail.com
                  </td>
                </tr>

                <tr className="border-b border-gray-200">
                  <th className="py-4 px-6 bg-gray-50 text-left text-gray-700 font-medium">販売価格</th>
                  <td className="py-4 px-6">
                    <ul className="list-disc pl-5 space-y-1">
                      <li>ベーシックプラン: 2,980円/月（税込）</li>
                      <li>スタンダードプラン: 4,980円/月（税込）</li>
                      <li>プロフェッショナルプラン: 9,800円/月（税込）</li>
                      <li>エンタープライズプラン: 14,800円/月（税込）</li>
                      <li>追加AIクレジット: 2,980円/500回（税込）</li>
                      <li>追加AIクレジット: 4,980円/1,000回（税込）</li>
                    </ul>
                  </td>
                </tr>

                <tr className="border-b border-gray-200">
                  <th className="py-4 px-6 bg-gray-50 text-left text-gray-700 font-medium">追加手数料等の追加料金</th>
                  <td className="py-4 px-6">商品・サービスの代金以外に発生する料金はありません。</td>
                </tr>

                <tr className="border-b border-gray-200">
                  <th className="py-4 px-6 bg-gray-50 text-left text-gray-700 font-medium">支払方法</th>
                  <td className="py-4 px-6">クレジットカード決済のみ（Visa, Mastercard, American Express, JCB）</td>
                </tr>

                <tr className="border-b border-gray-200">
                  <th className="py-4 px-6 bg-gray-50 text-left text-gray-700 font-medium">商品の引渡時期</th>
                  <td className="py-4 px-6">お申し込み完了後、即時にサービスをご利用いただけます。</td>
                </tr>

                <tr className="border-b border-gray-200">
                  <th className="py-4 px-6 bg-gray-50 text-left text-gray-700 font-medium">返品・キャンセルについて</th>
                  <td className="py-4 px-6">
                    <p className="mb-4">デジタルコンテンツの性質上、お申し込み後のキャンセル・返金はお受けしておりません。</p>
                    <p className="mb-4">ただし、サービス提供に重大な不具合があった場合は、個別にご対応いたします。</p>
                    <p className="mb-4">サブスクリプションは、いつでも解約可能です。解約後は次回の請求日以降、サービスのご利用ができなくなります。</p>
                    
                    <h3 className="text-lg font-medium mt-4 mb-2">＜お客様都合の解約の場合＞</h3>
                    <p className="mb-4">アカウント設定画面から、いつでも解約手続きが可能です。解約後は次回の請求日以降、サービスのご利用ができなくなります。日割り計算での返金は行っておりません。</p>
                    
                    <h3 className="text-lg font-medium mt-4 mb-2">＜サービスに不備がある場合＞</h3>
                    <p>サービス提供に重大な不具合があった場合は、お問い合わせフォームよりご連絡ください。状況を確認の上、個別に対応いたします。</p>
                  </td>
                </tr>

                <tr className="border-b border-gray-200">
                  <th className="py-4 px-6 bg-gray-50 text-left text-gray-700 font-medium">ソフトウェアの動作環境</th>
                  <td className="py-4 px-6">
                    <ul className="list-disc pl-5 space-y-1">
                      <li>対応ブラウザ: Google Chrome (最新版)、Mozilla Firefox (最新版)、Safari (最新版)、Microsoft Edge (最新版)</li>
                      <li>推奨環境: 4GB以上のRAM、高速インターネット接続</li>
                      <li>対応デバイス: PC、タブレット（画面サイズ9.7インチ以上推奨）</li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}